import { createApp, h } from 'vue';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import FavoriteCarButton from "./vue/components/favoriteCarButton.vue";

const favoritButtonAppSelector = ".favorite-button-app";
const favoriteButtonAppElements = document.querySelectorAll(favoritButtonAppSelector);
const favoriteButtonApps = [];
if (favoriteButtonAppElements) {
    favoriteButtonAppElements.forEach(app => {
        const vehiclePageId = app.dataset.vehiclePageId;
        const vehicleId = app.dataset.vehicleId;
        const preLiked = app.dataset.preLiked == "True";
        const seedData = {
            vehicleNodeId: vehiclePageId,
            vehicleId: vehicleId,
            preLiked:preLiked,
            wrapClass:"",
            buttonClass:"p-button-secondary p-button-outlined vehicle-info__like-button"
        };

        favoriteButtonApps.push(createApp({
            data() { return seedData },
            render: () => h(FavoriteCarButton)
        }, seedData).use(ToastService).use(PrimeVue).mount('#' + app.id));
    });
}
